<div class="product-grid">
  <div class="row">
    <div class="product-card col-12 col-sm-6 col-md-4" (click)="viewNewsDetails(list)" *ngFor="let list of newsList">
      <div class="product-card__image-wrapper">
        <img [src]="fileDirectoriesPath + list?.thumbnail" [alt]="list?.title" class="product-card__image" />
        <span class="product-card__tag"> {{ list?.sport?.name | titlecase }} </span>
      </div>
      <div class="product-card__info">
        <span>{{ list?.createdAt | date: DATE_FORMAT }}</span>
        <h3 class="ellipsis">{{ list?.title | titlecase }}</h3>
        <p class="ellipsis" [innerHtml]="list?.description | titlecase"></p>
        <button class="text-red handPointer" (click)="viewNewsDetails(list)">Learn more</button>
      </div>
    </div>
    <div class="searchResult" *ngIf="pagination.row == 0 && pagination.text != 'Loading...'">
      <div class="searching text-center">
        <h5>{{ pagination.text || '' }}</h5>
      </div>
    </div>
  </div>
</div>
